"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThumbnailVideoUrlsFromJSON = ThumbnailVideoUrlsFromJSON;
exports.ThumbnailVideoUrlsFromJSONTyped = ThumbnailVideoUrlsFromJSONTyped;
exports.ThumbnailVideoUrlsToJSON = ThumbnailVideoUrlsToJSON;
exports.ThumbnailVideoUrlsToJSONTyped = ThumbnailVideoUrlsToJSONTyped;
const runtime_1 = require("../runtime");
function ThumbnailVideoUrlsFromJSON(json) {
    return ThumbnailVideoUrlsFromJSONTyped(json, false);
}
function ThumbnailVideoUrlsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sD': !(0, runtime_1.exists)(json, 'SD') ? undefined : json['SD'],
        'hD': !(0, runtime_1.exists)(json, 'HD') ? undefined : json['HD'],
    };
}
function ThumbnailVideoUrlsToJSON(value) {
    return ThumbnailVideoUrlsToJSONTyped(value, false);
}
function ThumbnailVideoUrlsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'SD': value.sD,
        'HD': value.hD,
    };
}
